import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import en from '../i18n/en';
import ru from '../i18n/ru';
import es from '../i18n/es';
import uk from '../i18n/uk';

const dictionaries = { en, ru, es, uk };
export const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'ru', label: 'RU' },
  { code: 'es', label: 'ES' },
  { code: 'uk', label: 'UA' },
];

const LanguageContext = createContext(null);

function detectInitial() {
  const saved = localStorage.getItem('alef_lang');
  if (saved && dictionaries[saved]) return saved;
  const nav = (navigator.language || 'en').slice(0, 2).toLowerCase();
  return dictionaries[nav] ? nav : 'en';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = useCallback((code) => {
    if (!dictionaries[code]) return;
    localStorage.setItem('alef_lang', code);
    setLangState(code);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const resolve = (dict) => path.split('.').reduce((acc, k) => (acc == null ? acc : acc[k]), dict);
    const val = resolve(dictionaries[lang]);
    if (val !== undefined) return val;
    return resolve(dictionaries.en) ?? path;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
